"use client";

import styled from "styled-components";

type Props = {
  xPos: number | string;
  yPos: number | string;
};

export const ContextMenuAnchor = styled.div<Props>`
  position: fixed;
  top: ${props => props.yPos};
  left: ${props => props.xPos};
  height: 1px;
  width: 1px;
  background: transparent;
  pointer-events: none;
`;

export default ContextMenuAnchor;
